import { t } from "i18next";
import React from "react";

import { ComponentsLoader, Paginator } from "components";
import { TableWrapper } from "components/Tables";
import { INotificationHistory } from "redux/notifications/reducer";
import withNotificationsData from "./withNotificationsData";
import type { IRequestParams } from "redux/notifications/reducer";
import Loader from "pages/Loader";

type IMappedNotification = Pick<INotificationHistory, "id" | "createdAt" | "title">

interface INotificationsWithActions extends IMappedNotification {
    view: React.ReactElement,
    status: React.ReactElement
}

export interface INotificationsProps {
    notifications: INotificationsWithActions[] | null | undefined,
    getParams: IRequestParams,
    total: number | null | undefined,
    error: string | null,
    isLoading: boolean,
    changeNotificationPageHandler: (page: number) => void,
}

const Notifications: React.FC<INotificationsProps> = ({
    notifications,
    getParams,
    total,
    error,
    isLoading,
    changeNotificationPageHandler
}) => {

    const header = (
        <div className="bg-white pb-6">
            <span className="text-slate-800 font-bold">
                {t<string>("notifications")}:
            </span>
            <span className="text-slate-400 ml-2">
                {total && total}
            </span>
        </div>
    );

    const pagination = (
        <>
            {
                total &&
                <Paginator 
                    pageSize={getParams.limit} 
                    total={total} 
                    page={getParams.page - 1} 
                    callback={changeNotificationPageHandler} 
                />
            }
        </>
    );

    const head = [
        {
            name: "ID"
        },
        {
            name: t("created_at").toUpperCase()
        },
        {
            name: t("name").toUpperCase()
        },
        {
            name: t("status").toUpperCase()
        },
        {
            name: t("more").toUpperCase()
        }
    ];


    return (
        <div className="m-4">
            <TableWrapper
                header={header}
                head={head}
                // @ts-ignore
                data={notifications}
                className="p-4 border border-slate-200 shadow-md"
                pagination={pagination}
                isLoading={isLoading}
                error={error}
            />
        </div>
    )
}

export default withNotificationsData(Notifications);